import React from 'react';
import { cn } from '../../utils/cn';
import { getDocumentStatusMeta } from '../../utils/documentStatusMeta';

const DocumentStatusBadge = ({ status, className, size = 'sm' }) => {
  const meta = getDocumentStatusMeta(status);
  const sizeClass =
    size === 'xs'
      ? 'text-[10px] px-2 py-0.5'
      : 'text-xs px-2.5 py-1';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium whitespace-nowrap',
        sizeClass,
        meta.className,
        className
      )}
    >
      {meta.label}
    </span>
  );
};

export default DocumentStatusBadge;
